// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"a80b264d","349":"30224752","530":"3933cdc0","706":"705baa66","984":"942acac0"}[chunkId] + ".chunk.css";
};